import omitDeep from 'omit-deep-lodash';

export function omitTypeName<T extends object>(value: T): T {
  return omitDeep(value, '__typename') as T;
}
